// extracted by mini-css-extract-plugin
export default {"project":"Project_project__lDckh","image":"Project_image__iEaYT","title":"Project_title__QNf02","skills":"Project_skills__ROboH"};